import { useState, useEffect, useRef } from "react";
import { toast } from "sonner";
import { Upload, Trash2, Loader2 } from "lucide-react";
import adminApi from "@/lib/adminApi";
import { Button } from "@/components/ui/button";
import { resolveImg } from "@/components/comments/CommentMeta";

export default function AvatarsTab() {
  const [avatars, setAvatars] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => adminApi.get("/avatars").then((r) => setAvatars(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (files) => {
    if (!files?.length) return;
    setUploading(true);
    for (const file of files) {
      const form = new FormData();
      form.append("file", file);
      await adminApi.post("/admin/avatars", form).catch((e) => toast.error(e.response?.data?.detail || `Error con ${file.name}`));
    }
    setUploading(false);
    fileRef.current.value = "";
    toast.success("Avatares subidos");
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar este avatar? Los fans que lo usan lo conservarán.")) return;
    await adminApi.delete(`/admin/avatars/${id}`);
    load();
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-4 md:p-6 shadow-sm" data-testid="admin-avatars-tab">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 mb-5">
        <p className="text-sm text-gray-500">Se recortan en cuadrado a 256×256. A cada fan nuevo se le asigna uno al azar.</p>
        <input ref={fileRef} type="file" multiple accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={(e) => upload(e.target.files)} />
        <Button onClick={() => fileRef.current?.click()} disabled={uploading} className="bg-[#E91E8C] hover:bg-[#E91E8C]/90 text-white" data-testid="admin-avatar-upload-btn">
          {uploading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />} Subir avatares
        </Button>
      </div>
      {avatars.length === 0 ? (
        <p className="text-gray-500 text-sm py-8 text-center" data-testid="admin-avatars-empty">Aún no hay avatares</p>
      ) : (
        <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-4">
          {avatars.map((a) => (
            <div key={a.id} className="relative group" data-testid={`admin-avatar-${a.id}`}>
              <img src={resolveImg(a.image_url)} alt="" className="w-full aspect-square rounded-full object-cover bg-gray-100 border border-gray-200" />
              <button onClick={() => remove(a.id)} className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full p-1 md:opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`admin-avatar-delete-${a.id}`}>
                <Trash2 className="w-3 h-3" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
